import React, { memo } from "react";

import { Container, SubTitleText, ActionsSection, ActionButton } from "../styled";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TEXTS } from "@cart-ui/constants";

const SelectOrderType = ({ onSelectOrderTypeClick }: { onSelectOrderTypeClick: VoidFunction }) => {
    return (
        <Container>
            <Text variant="V2.subheading1.neutral.bold" color="text_Highest_Emphasis">
                {TEXTS.SELECT_ORDER_TYPE_HEADING}
            </Text>
            <SubTitleText variant="V2.body3.neutral.medium" color="text_Med_Emphasis">
                {TEXTS.SELECT_ORDER_TYPE_SUBTITLE}
            </SubTitleText>

            <ActionsSection>
                <ActionButton
                    onClick={onSelectOrderTypeClick}
                    buttonType="primary"
                    buttonSize="large"
                    variant="fullwidth"
                >
                    {TEXTS.SELECT_ORDER_TYPE_CTA}
                </ActionButton>
            </ActionsSection>
        </Container>
    );
};

export default memo(SelectOrderType);
